import {
  GET_ACQUISITION_CHANNEL_LIST,
  GET_ACQUISITION_CHANNEL_LIST_SUCCESS,
  GET_ACQUISITION_CHANNEL_LIST_FAILURE,
  GET_ACQUISITION_CHANNEL_DATA,
  GET_ACQUISITION_CHANNEL_DATA_SUCCESS,
  GET_ACQUISITION_CHANNEL_DATA_FAILURE,
  CREATE_ACQUISITION_CHANNEL,
  CREATE_ACQUISITION_CHANNEL_SUCCESS,
  CREATE_ACQUISITION_CHANNEL_FAILURE,
  UPDATE_ACQUISITION_CHANNEL,
  UPDATE_ACQUISITION_CHANNEL_SUCCESS,
  UPDATE_ACQUISITION_CHANNEL_FAILURE,
  DELETE_ACQUISITION_CHANNEL,
  DELETE_ACQUISITION_CHANNEL_SUCCESS,
  DELETE_ACQUISITION_CHANNEL_FAILURE,
} from "./actionType";

// Actions
// Get Acquisition Channel List
export const getAcquisitionChannelList = () => ({
  type: GET_ACQUISITION_CHANNEL_LIST,
});
export const getAcquisitionChannelListSuccess = (data) => ({
  type: GET_ACQUISITION_CHANNEL_LIST_SUCCESS,
  payload: data,
});
export const getAcquisitionChannelListFailure = () => ({
  type: GET_ACQUISITION_CHANNEL_LIST_FAILURE,
});

// Get Acquisition Channel data
export const getAcquisitionChannelData = (id) => ({
  type: GET_ACQUISITION_CHANNEL_DATA,
  payload: id,
});
export const getAcquisitionChannelDataSuccess = (data) => ({
  type: GET_ACQUISITION_CHANNEL_DATA_SUCCESS,
  payload: data,
});
export const getAcquisitionChannelDataFailure = () => ({
  type: GET_ACQUISITION_CHANNEL_DATA_FAILURE,
});

// Create Acquisition Channel
export const createAcquisitionChannel = (data) => ({
  type: CREATE_ACQUISITION_CHANNEL,
  payload: data,
});
export const createAcquisitionChannelSuccess = (data) => ({
  type: CREATE_ACQUISITION_CHANNEL_SUCCESS,
  payload: data,
});
export const createAcquisitionChannelFailure = () => ({
  type: CREATE_ACQUISITION_CHANNEL_FAILURE,
});

// Update Acquisition Channel
export const updateAcquisitionChannel = (data) => ({
  type: UPDATE_ACQUISITION_CHANNEL,
  payload: data,
});
export const updateAcquisitionChannelSuccess = (data) => ({
  type: UPDATE_ACQUISITION_CHANNEL_SUCCESS,
  payload: data,
});
export const updateAcquisitionChannelFailure = () => ({
  type: UPDATE_ACQUISITION_CHANNEL_FAILURE,
});

// Delete Acquisition Channel
export const deleteAcquisitionChannel = (id) => ({
  type: DELETE_ACQUISITION_CHANNEL,
  payload: id,
});
export const deleteAcquisitionChannelSuccess = (data) => ({
  type: DELETE_ACQUISITION_CHANNEL_SUCCESS,
  payload: data,
});
export const deleteAcquisitionChannelFailure = () => ({
  type: DELETE_ACQUISITION_CHANNEL_FAILURE,
});
